/* PetalHush Dog Breeds product page (sections/ph-breed-product.liquid, P-016). No app, no dependencies.
   - Material radios are the variant input (name="id"); breed tiles are a radio group (properties[Breed]).
   - Photo 1 + _Consent: same rules as assets/petalhush-product.js (file types, size, small-photo warning,
     a rejected file never replaces a good one: QA R2). Ported, not shared, so the live PDP script is untouched.
   - Cart: the fee lines first, in ONE JSON /cart/add.js call: back engraving ("_Back engraving for") and, when a photo
     is attached, the photo fee ("_Photo for"), both = "SKU · Breed" and both carrying "_Pair id". Then the piece
     (multipart /cart/add, carries the photo file, "_Pair id" and "_Breed image"); if the piece fails, the fee lines
     are removed again (/cart/update.js). snippets/ph-cart-pair-sync removes fee lines whose piece is gone.
   - P-086 matching set (snippets/ph-matching-set, assets/ph-matching-set.js): only when a piece is ticked, addMain()
     hands the FormData to window.PetalHushSet (main item + pieces; the back message / fee stay on the main item).
     Nothing ticked (or no set block) = the flow below, unchanged.
   - Breed picker (r4): a compact field opens a sheet (bottom sheet on phones, modal on desktop): search, a list of
     radio rows (first C.t.firstRows, then "View all"), "Browse A–Z" letter index. role=dialog + aria-modal, focus
     trap, Esc, focus returns to the field. Without JS the list shows inline (no .js-sheet).
   - "_Breed image" = the chosen breed x colour image from our Files (the main image's URL, unsized). The theme cart
     (snippets/ph-cart-line-image) shows it instead of the variant image.
   - Single-design mode (P-027, C.single, template product.design-charm): no breed tiles/sheet/properties and no breed
     check; slide 1 swaps to the selected Material radio's data-img / data-img-set / data-img-alt; the sticky bar shows
     the material; the fee lines' "_… for" = SKU · product title (C.title). Every change is behind SINGLE, so breed
     mode runs exactly as before.
   - Free text fields (P-041, single design only, C.text; template product.quote-watch): counter + charset check like the
     back message, required unless optional, errors in the summary, values trimmed + NFC and posted as visible properties
     named by the label; the limit counts the trimmed NFC value. No fee line.
   - Souly studio fields (P-045, single design only, C.studio; template product.general-charm-black-cord-bracelet): the
     custom.personalize fields rendered by the section. Photo fields = native file inputs (same type/size/small-photo
     checks as Photo 1, a rejected file never replaces a good one), posted in the multipart form so the property holds
     the upload URL; required ones block Add to bag. Text / number / initial(s) / year: counter + format checks, values
     trimmed (initials upper-cased). A "count" select enables only the first N repeated fields. _Consent posts with a
     studio photo too. No fee line. Every change is behind SZ (C.studio), so the other templates run as before.
   - AI preview (P-048, C.preview, only with SZ; section setting ai_preview): after a valid photo in the FIRST studio photo
     field, the photo is shrunk (<= 2048 px, JPEG 0.85) and posted to C.preview.start (App Proxy /apps/ph-preview/start),
     then C.preview.status is polled every 4 s (max 4 min of visible time, paused while the tab is hidden).
     P-066: the pill shows AT ONCE in a loading state (aria-disabled, label t.loading, a time-based rose-gold bar: ease-out
     to 90 % at 30 s, then a crawl toward 97 %; stepwise under reduced motion) with the hint t.hint under it. Done: the bar
     fills, then the first look itself (caption t.title + image) shows right under the photo tile, inline (founder
     2026-10-26: no "See a first look" button, no pop-up); a hidden properties[_Preview] = the render URL joins the form.
     Failed / off / timeout / network error / broken image: the pill is replaced by one quiet line (t.fail).
     properties[_Preview job] (hidden) = the job id (a client ref "c-…" until /start answers) posts with Add to bag, so the
     global snippets/ph-cart-preview can finish the job in the cart. Jobs are kept in localStorage ph_pv_jobs
     ({id: {t0, status, url, pid, t}}, last 10, < 24 h). Events "ph:pv:job" tell the cart writer about done / failed /
     released jobs; window.PetalHushPvLive marks the job this page is polling (the cart writer then doesn't poll it too).
     Replace or Remove aborts the job (AbortController + job token), unless that job is already in the bag (then its
     request finishes and the cart writer takes over). Add to bag never waits for it.
     No Turnstile site key = no preview at all: the photo never leaves the browser (lead, QA loop 1; the Worker requires a token).
     P-111 (theme/P-111-FIRST-LOOK-SPEED.md): S1 photo.pvGate = a promise resolved once /start answers / fails / is skipped
     (or the job is cleared); assets/ph-photo-up.js holds the full-size pre-upload of that photo until then (≤ 15 s), so the
     2048 px copy has the uplink to itself. S2 the Turnstile script loads, and one invisible token is fetched, on the first
     tap / focus / drag on the first photo field (intent), not on page load; that token is used by the next /start if it is
     < 4 min old. S3 status is polled every 2 s for the first 40 s of visible polling, then every 4 s; the cap is still
     4 min of visible time.
   - P-084 photo upload (C.photoField, section setting photo_field): Photo 1 shows at once, with no tick. FREE (founder
     2026-10-26): C.photoAddon is null, so no fee line is ever added. Optional; "Mixed breed or not listed" makes it
     required (T.photoRequired). Once a valid photo decodes it runs the same first look (PV) as the studio photo field.
     Every hunk is behind PF, so the tick flow and the studio pages run as before.
   - P-092b quantity tiles + gift box add-on (snippets/ph-qty-tiers, ph-addon-box, assets/ph-qty-addon.js): three hooks to
     window.PetalHushQB, each skipped when that file isn't on the page (every template without the blocks): update() lets
     it adjust the Total (tile price x quantity + ticked boxes), paintSel() the sticky name, and addToBag() appends its
     lines (the gift box) to the add-on /cart/add.js call, so they are rolled back with the fee lines if the piece fails.
   - P-106 Size option (C.size, section setting opt_size; theme/P-106-PETAL-SIZE.md): the Size pills post nothing (the Material
     radio stays the variant). A size change rewrites every Material radio from its data-sz map (id, price, compare-at,
     available, SKU, image); a Material without that size stays clickable (data-na) and picking it switches the size back
     (status line + undo). The checked Material without the new size switches by C.size.map (closest color + undo) or, for
     "ask", is unchecked and Add to bag asks for one (S.sizeAsk). Programmatic switches fire "change" on the radio with
     S.sizeQuiet, so onMetal, the premium cards and the URL follow. No C.size: nothing below runs. */
(function () {
  if (window.PetalHushBreed) return;
  window.PetalHushBreed = true;

  var ALLOWED = /^[A-Za-z0-9 &.'\-♥éèàüöäñçøåÉÈÀÜÖÄÑÇØÅ]*$/u;   // same set as the main PDP
  var STRICT = /^[A-Za-z0-9 &.'\-]*$/;   // P-113b S3: a studio field with "charset": "strict" (data-charset): no ♥, accents or emoji
  var NAMES = /^[A-Za-zÀ-ÖØ-öø-ÿĀ-ſȘ-ț .'’\-]*$/u;   // P-041 names (lead 2026-10-14): Latin letters incl. accents (Latin-1, Extended-A, Romanian Ș-ț), spaces, . ' - (’ = iOS apostrophe)
  var FILE_EXT = ['jpg', 'jpeg', 'png', 'heic', 'heif', 'webp'];
  // Meta pixel (2026-10-27, lead): one "photo_uploaded" customer event per product per page, on the first photo that
  // decodes. The theme only publishes it; the Shopify custom pixel "PetalHush Meta photo upload" (Settings > Customer
  // events, consent = Marketing) turns it into Meta PhotoUpload + CustomizeProduct. No pixel code in the theme.
  function phPhotoEvent(field) {
    try {
      var A = window.Shopify && window.Shopify.analytics;
      if (!A || typeof A.publish !== 'function' || (window.Shopify && window.Shopify.designMode)) return;
      var m = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) || {};
      var key = String(m.id || location.pathname), sent = window.__phPhotoSent = window.__phPhotoSent || {};
      if (sent[key]) return;
      sent[key] = 1;
      var cents = null;
      (m.variants || []).forEach(function (v) { if (typeof v.price === 'number' && (cents === null || v.price < cents)) cents = v.price; });
      A.publish('photo_uploaded', {
        product_id: m.id ? String(m.id) : '', product_type: m.type || '', field: field || 'photo',
        value: cents === null ? null : cents / 100, currency: (window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      });
    } catch (e) { /* tracking never breaks the upload */ }
  }
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EDITOR = !!(window.Shopify && window.Shopify.designMode);

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(s) {   // [PLACEHOLDER] copy: dropped on the storefront, outlined in the editor (as snippets/ph-text)
    s = String(s == null ? '' : s);
    if (!EDITOR && s.indexOf('[PLACEHOLDER') !== -1) return '';
    return esc(s).replace(/\[PLACEHOLDER[^\]]*\]/g, function (m) { return '<span class="ph-pending">' + m + '</span>'; });
  }
  function tpl(s, map) { return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function money(cents, format) {
    var n = cents / 100, whole = Math.round(n) === n;
    var f = format || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      var v = whole ? String(n) : n.toFixed(2);
      if (k.indexOf('comma') !== -1) v = v.replace('.', ',');
      return v.replace(/\B(?=(\d{3})+(?!\d))/g, k.indexOf('comma') !== -1 ? '.' : ',');
    });
  }
  function norm(s) { return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function sized(u, w) { return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; }
  function keepFile(input, file) {
    if (!file) { input.value = ''; return; }
    try { var dt = new DataTransfer(); dt.items.add(file); input.files = dt.files; } catch (e) { /* old browsers keep their value */ }
  }

  /* P-102: the bag add got faster (theme/P-102-BAG-SPEED.md). The customer's photo goes up inside the multipart
     /cart/add: 5–30 s on a phone network. 1) Very big JPEG/PNG/WebP files (> 3 MB, or longest side > 4096 px) get a
     background copy as soon as they decode: longest side <= C.photoMaxPx (theme setting ph_photo_max_px, default 4096;
     "0" = off), JPEG q 0.88 on white, EXIF orientation applied by the browser; the copy is used only when it is at least
     25 % smaller. HEIC/HEIF always go as uploaded (iPhone HEIC is already smaller than any JPEG of it). Add to bag waits
     at most 3 s for a copy still being made (then the original goes) and swaps each photo in the FormData for its copy
     BEFORE the direct add or the set / B3 / AC modules get it. 2) The direct add uses XMLHttpRequest so the busy line
     shows the upload ("Adding to your bag… 45%") and an open bag a thin rose-gold bar. The first look keeps its own
     2048 px copy; type/size checks and the small-photo warning are unchanged. */
  var PH_SLIM_FROM = 3 * 1024 * 1024, PH_SLIM_GAIN = 0.75, PH_SLIM_WAIT = 3000;
  function phSlimMax(C) {
    var n = parseInt(C && C.photoMaxPx, 10);
    if (n === 0) return 0;   // off: always the original
    return n >= 1024 && n <= 8192 ? n : 4096;
  }
  function phSlimStart(photo, img, C) {   // photo = a field's state ({file, ...}); img = its decoded probe <img>
    var max = phSlimMax(C), f = photo && photo.file;
    if (!f) return;
    photo.slim = null;
    photo.slimP = new Promise(function (res) {
      try {
        var ext = (String(f.name || '').split('.').pop() || '').toLowerCase();
        var raster = /^image\/(jpeg|png|webp)$/.test(f.type) || (!f.type && /^(jpe?g|png|webp)$/.test(ext));
        var w = img.naturalWidth, h = img.naturalHeight, L = Math.max(w, h);
        if (!max || !raster || !L || (L <= max && f.size <= PH_SLIM_FROM)) return res(null);   // HEIC/HEIF and normal photos: as uploaded
        var k = Math.min(1, max / L), c = document.createElement('canvas');
        if (!c.getContext || !c.toBlob) return res(null);
        c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(h * k));
        var g = c.getContext('2d'); if (!g) return res(null);
        g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height); g.drawImage(img, 0, 0, c.width, c.height);
        c.toBlob(function (b) { c.width = c.height = 0; res(b && b.size && b.size <= f.size * PH_SLIM_GAIN ? b : null); }, 'image/jpeg', 0.88);
      } catch (e) { res(null); }
    }).then(function (b) { photo.slim = b; return b; });
  }
  function phSlimFd(fd, list) {   // list = [[field name, photo state], ...]; resolves once every copy is ready, or after 3 s
    var todo = list.filter(function (x) { return x[0] && x[1] && x[1].slimP && fd.has(x[0]); });
    var swap = function () {
      todo.forEach(function (x) {
        var p = x[1], cur = fd.get(x[0]);
        if (!p.slim || !cur || typeof cur === 'string' || cur.size !== p.file.size || cur.name !== p.file.name) return;   // only the file the copy was made from
        fd.set(x[0], p.slim, (String(p.file.name || '').replace(/\.[^.]*$/, '') || 'photo') + '.jpg');
      });
    };
    if (!todo.length) return Promise.resolve();
    return Promise.race([Promise.all(todo.map(function (x) { return x[1].slimP; })),
      new Promise(function (r) { setTimeout(r, PH_SLIM_WAIT); })]).then(swap, swap);
  }
  function phBusyPct(T, n) {   // n = 0–99 while the photo uploads; null = the plain busy line again
    var h = document.documentElement, txt = T.addingBag || 'Adding to your bag…';
    if (n == null) { h.removeAttribute('data-ph-pct'); h.style.removeProperty('--ph-adding-pct'); }
    else { txt += ' ' + n + '%'; h.setAttribute('data-ph-pct', ''); h.style.setProperty('--ph-adding-pct', n + '%'); }
    h.style.setProperty('--ph-adding-text', JSON.stringify(txt));
  }
  function phPost(url, fd, T) {   // the multipart add as XHR (upload progress); same JSON + errors as the fetch it replaces
    return new Promise(function (res, rej) {
      var x = new XMLHttpRequest(), last = -1;
      x.open('POST', url, true);
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest'); x.setRequestHeader('Accept', 'application/javascript');
      if (x.upload) x.upload.onprogress = function (e) {
        if (!e.lengthComputable || e.total < 262144) return;   // no photo in the body: no number
        var n = Math.min(99, Math.floor(e.loaded / e.total * 100));
        if (n !== last) { last = n; phBusyPct(T, n); }
      };
      x.onload = function () {
        phBusyPct(T, null);
        var j; try { j = JSON.parse(x.responseText); } catch (e) { return rej(e); }
        if (x.status < 200 || x.status >= 300 || !j || j.status) return rej(j || new Error('empty response'));
        res(j);
      };
      x.onerror = x.onabort = x.ontimeout = function () { phBusyPct(T, null); rej(new TypeError('Network request failed')); };
      x.send(fd);
    });
  }
  /* P-102 end */

  /* P-102b: photo pre-upload (theme/P-102-BAG-SPEED.md, phase 2; assets/ph-photo-up.js = window.PetalHushUp, loaded by
     the section when theme setting ph_photo_up_on is on). Once a photo decodes it goes up in the background; Add to bag
     then posts its URL instead of the file (about 1 s), waits for an unfinished upload with "Adding to your bag… n%",
     and keeps the phase 1 multipart add (Shopify upload) whenever the pre-upload is off, failed or stalled. */
  function phUpStart(photo, img, C, name) {
    try { if (window.PetalHushUp && C.upload) window.PetalHushUp.start(photo, img, C, name); } catch (e) { /* the Shopify upload stays */ }
  }
  function phUpDrop(name) {   // the field's photo was removed or replaced: its running upload stops (QA m4)
    try { if (window.PetalHushUp && window.PetalHushUp.drop) window.PetalHushUp.drop(name); } catch (e) { /* nothing to stop */ }
  }
  function phUpFd(fd, list, T) {   // → the photo fields still sent as files (phase 1 shrinks those next)
    if (!window.PetalHushUp || !list.length) return Promise.resolve(list);
    return window.PetalHushUp.apply(fd, list, function (n) { phBusyPct(T, n); }).catch(function () { return list; });
  }
  /* P-102b end */

  function init(root) {
    if (root.dataset.phReady) return;
    root.dataset.phReady = '1';
    var C = JSON.parse(root.querySelector('[data-ph-breed-config]').textContent);
    var T = C.t;
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var form = $('[data-ph-form]');
    if (!form) return;
    form.noValidate = true;   // our own checks; without JS the browser's "required" still guards the breed
    var COLORS = C.colors || ['silver', 'gold', 'rose-gold'];
    var SINGLE = C.single === true;   // P-027 single-design mode
    var S = { photo: null, back: false, tried: false, showAll: false, az: false };

    /* ---------- state helpers ---------- */
    var metals = $$('input[name="id"]');
    var tiles = $$('[data-ph-bgrid] input[type=radio]');
    function metal() { return metals.filter(function (m) { return m.checked; })[0] || metals[0]; }
    function color() { var m = metal(); return m ? m.dataset.color : 'silver'; }
    function ci() { var i = COLORS.indexOf(color()); return i < 0 ? 0 : i; }
    function breed() { return tiles.filter(function (t) { return t.checked; })[0] || null; }
    function urlOf(tile) { return (tile.dataset.u || '').split(' ')[ci()] || ''; }
    function isCustom() { var b = breed(); return !!(b && b.dataset.slug === 'custom'); }   // "Mixed breed or not listed"
    // P-062: quantity = the form's hidden quantity input (1 unless the ph-upsell "Make it two" block set it). The total, the
    // sticky price and the add-on fee lines follow it (fee qty = piece qty, as snippets/ph-cart-pair-sync keeps them).
    var qtyEl = form.querySelector('input[name="quantity"]');
    function qty() { var n = qtyEl ? parseInt(qtyEl.value, 10) : 1; return n >= 1 && n <= 99 ? n : 1; }
    if (qtyEl) qtyEl.addEventListener('change', function () { update(); });   // update() also repaints the sticky name (paintSel)
    var backBox = root.querySelector('[data-ph-back]');
    var PF = C.photoField || null;   // P-084: the upload tile itself, no tick, no fee
    function photoWanted() { if (PF) return !!(S.photo && file && file.files && file.files.length); var c = root.querySelector('[data-ph-photo-on]'); return !!(c && c.checked && C.photoAddon); }   // box ticked = +fee; P-084: a photo is attached
    function hasPhoto() { return !!(photoWanted() && S.photo && file && file.files && file.files.length); }   // a file will actually post

    /* ---------- gallery ---------- */
    var track = $('[data-ph-track]'), thumbs = $('[data-ph-thumbs]'), main = $('[data-ph-bmain]');
    var chip = $('[data-ph-bchip]'), illus = $('[data-ph-billus]'), chipText = chip ? chip.textContent : '';
    var exampleSlug = null, exampleU = null, exampleName = '';
    if (main) {   // remember the example breed rendered by Liquid, so a metal change recolours it
      var ex = tiles.filter(function (t) { return t.dataset.slug !== 'custom' && (main.src.indexOf('-' + t.dataset.slug + '-') !== -1 || main.src.indexOf(t.dataset.u.split(' ')[ci()].split('?')[0]) === 0); })[0];
      if (ex) { exampleSlug = ex.dataset.slug; exampleU = ex.dataset.u; exampleName = ex.value; }
    }
    function slides() { return $$('[data-ph-track] .ph-slide'); }
    function renderThumbs() {
      if (!thumbs) return;
      var list = slides();
      if (list.length < 2) { thumbs.innerHTML = ''; return; }
      thumbs.innerHTML = list.map(function (s, i) {
        var img = s.querySelector('img'), vid = s.hasAttribute('data-ph-vslide');   // P-060: a video slide gives its poster thumb
        var src = vid ? (s.getAttribute('data-ph-thumb') || '') : img ? (img.currentSrc || img.src) : '';
        return '<button type="button"' + (vid ? ' class="ph-thumb-video"' : '') + ' aria-label="' + esc((i + 1) + ' / ' + list.length) + '" aria-current="' + (i === 0) + '">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '<span class="ph-t-ph"></span>') + '</button>';
      }).join('');
      Array.prototype.forEach.call(thumbs.querySelectorAll('button'), function (b, i) { b.addEventListener('click', function () { goTo(i); }); });
    }
    function goTo(i) { if (track) track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); }
    if (track) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (thumbs) Array.prototype.forEach.call(thumbs.querySelectorAll('button'), function (b, j) { b.setAttribute('aria-current', j === i); });
        slides().forEach(function (sl, j) { var v = j !== i && sl.querySelector('video'); if (v && !v.paused) v.pause(); });   // P-060: a film off screen stops
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.target && e.target.closest && e.target.closest('video')) return;   // P-060: arrow keys seek inside the player
        var i = Math.round(track.scrollLeft / track.clientWidth), n = slides().length;
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(n - 1, i + 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, i - 1)); }
      });
    }
    function paintSingle() {   // P-027: slide 1 = the selected material's variant image
      var m = metal(); if (!m || !m.dataset.img) return;
      if (main.getAttribute('src') !== m.dataset.img) {   // srcset first, so the browser fetches only one size
        if (m.dataset.imgSet) main.srcset = m.dataset.imgSet;
        main.src = m.dataset.img;
      }
      main.alt = m.dataset.imgAlt || '';
      var t0 = thumbs && thumbs.querySelector('button img');
      if (t0 && m.dataset.imgThumb) t0.src = m.dataset.imgThumb;
    }
    function paintMain() {
      if (!main) return;
      if (SINGLE) return paintSingle();
      var b = breed(), u, name;
      if (b) { u = urlOf(b); name = b.value; }
      else if (exampleU) { u = exampleU.split(' ')[ci()]; name = exampleName; }
      var mat = metal() ? metal().dataset.metal : '';
      if (u) {
        main.srcset = [600, 900, 1200].map(function (w) { return sized(u, w) + ' ' + w + 'w'; }).join(', ');
        main.src = sized(u, 900);
        main.alt = isCustom() ? tpl(T.customAlt, { material: mat }) : tpl(T.altTpl, { breed: name, material: mat });
      }
      if (chip) { chip.hidden = !!b && !isCustom(); chip.textContent = isCustom() ? T.customChip : chipText; }
      if (illus) {
        var md = (metal() ? metal().dataset.metal : '').toLowerCase();
        illus.hidden = !(C.illustrative || []).some(function (k) { k = k.trim(); return k && md.indexOf(k) !== -1; });
      }
      var first = thumbs && thumbs.querySelector('button img');
      if (first) first.src = sized(u || '', 160);
    }

    /* ---------- material ---------- */
    function paintTiles() {
      var i = ci();
      tiles.forEach(function (t) {
        var img = t.parentNode.querySelector('img'), u = (t.dataset.u || '').split(' ')[i];
        if (!img || !u || img.dataset.c === String(i)) return;
        img.dataset.c = String(i);
        img.srcset = [120, 180, 240].map(function (w) { return sized(u, w) + ' ' + w + 'w'; }).join(', ');
        img.src = sized(u, 180);
      });
    }
    function onMetal() {
      var m = metal(); if (!m) return;
      var name = $('[data-ph-metal-name]'); if (name) name.textContent = '· ' + m.dataset.metal;
      var d = $('[data-ph-metal-desc]'); if (d) d.innerHTML = fmt((C.metalDesc || {})[m.dataset.metal] || '');
      paintTiles(); paintMain(); paintSel(); update(); syncUrl();
      if (SINGLE) goTo(0);   // the swap is only visible on slide 1
    }
    metals.forEach(function (m) { m.addEventListener('change', onMetal); });

    /* ---------- P-106 size option (C.size) ---------- */
    var SIZE = C.size || null, sizeRadios = SIZE ? $$('[data-ph-size] input[type=radio]') : [], sizeLast = { size: '', metal: '', ask: false };
    function curSize() { var r = sizeRadios.filter(function (x) { return x.checked; })[0]; return r ? r.value : (SIZE ? SIZE.current || '' : ''); }
    if (SIZE && sizeRadios.length) (function () {
      var msgEl = $('[data-ph-size-msg]'), helpEl = $('[data-ph-size-help]'), nameEl = $('[data-ph-size-name]');
      metals.forEach(function (m) { var o = {}; try { o = JSON.parse(m.dataset.sz || '{}'); } catch (e) { /* no map: the card keeps its variant */ } m._sz = o; });
      var checkedMetal = function () { return metals.filter(function (x) { return x.checked; })[0] || null; };
      var byName = function (n) { n = String(n || '').toLowerCase(); return metals.filter(function (x) { return String(x.dataset.metal || '').toLowerCase() === n; })[0] || null; };
      var remember = function (ask) { var m = checkedMetal(); sizeLast = { size: curSize(), metal: m ? m.dataset.metal : sizeLast.metal, ask: !!ask }; };
      var fire = function (m) { S.sizeQuiet = true; try { m.dispatchEvent(new Event('change', { bubbles: true })); } finally { S.sizeQuiet = false; } };
      var say = function (text, undo, fn) {
        if (!msgEl) return;
        msgEl.innerHTML = text ? esc(text) + (undo ? ' <button type="button" class="ph-size-undo" data-ph-size-undo>' + esc(undo) + '</button>' : '') : '';
        var b = msgEl.querySelector('[data-ph-size-undo]'); if (b && fn) b.addEventListener('click', fn);
      };
      var apply = function (sz) {   // every Material card becomes its variant in this size
        metals.forEach(function (m) {
          var e = m._sz[sz], na = !e, k;
          if (na) { k = Object.keys(m._sz)[0]; e = k ? m._sz[k] : null; }
          if (!e) return;
          m.value = String(e[0]); m.dataset.price = String(e[1]); m.dataset.compare = e[2] > e[1] ? String(e[2]) : ''; m.dataset.sku = e[4] || '';
          if (e[5]) { m.dataset.img = e[5]; m.dataset.imgSet = e[6] || ''; m.dataset.imgThumb = e[7] || ''; m.dataset.imgAlt = e[8] || ''; }
          m.disabled = !e[3];
          if (na) m.dataset.na = '1'; else delete m.dataset.na;
          var lab = m.closest('label'), pr = lab ? lab.querySelector('[data-ph-mprice]') : null;
          if (lab) lab.classList.toggle('is-na', na);
          if (pr) pr.innerHTML = na ? esc(SIZE.t.na) : !e[3] ? esc(T.unavailable) : esc(money(e[1], C.moneyFormat)) + (e[2] > e[1] ? ' <s class="ph-compare">' + esc(money(e[2], C.moneyFormat)) + '</s>' : '');
          m.setAttribute('aria-label', m.dataset.metal + ', ' + (na ? SIZE.t.na : money(e[1], C.moneyFormat) + (e[3] ? '' : ', ' + T.unavailable)));
        });
        if (helpEl) helpEl.innerHTML = fmt((SIZE.help || {})[sz] || '');
        if (nameEl) nameEl.textContent = '\u00b7 ' + sz;
      };
      var setSize = function (sz) { sizeRadios.forEach(function (r) { r.checked = r.value === sz; }); apply(sz); };
      var restore = function (sz, metalName) {   // the undo button: that size + that material again
        return function () {
          setSize(sz);
          var m = byName(metalName);
          S.sizeAsk = false; say('');
          if (m && !m.dataset.na && !m.disabled) { m.checked = true; fire(m); }
          remember();
          var r = sizeRadios.filter(function (x) { return x.checked; })[0]; if (r) r.focus();
        };
      };
      sizeRadios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (!r.checked) return;
          var prev = sizeLast, sz = r.value;
          setSize(sz);
          var keep = byName(prev.metal);
          if (keep && !keep.dataset.na && !keep.disabled) { keep.checked = true; S.sizeAsk = false; say(''); fire(keep); remember(); return; }
          var to = (SIZE.map || {})[String(prev.metal || '').toLowerCase()], t = to && String(to).toLowerCase() !== 'ask' ? byName(to) : null;
          if (t && !t.dataset.na && !t.disabled) {   // closest color, said, with the way back
            t.checked = true; S.sizeAsk = false; fire(t);
            say(tpl(SIZE.t.switched, { new_material: t.dataset.metal }), prev.size ? tpl(SIZE.t.undo, { old_material: prev.metal }) : '', restore(prev.size, prev.metal));
            remember();
          } else {   // "ask" (10K Solid Gold, lead decision 1): no silent switch; Add to bag asks for a material
            metals.forEach(function (x) { x.checked = false; });
            S.sizeAsk = true; say(SIZE.t.ask);
            var nm = $('[data-ph-metal-name]'); if (nm) nm.textContent = '';
            sizeLast = { size: sz, metal: prev.metal, ask: true };
            paintSel();
          }
        });
      });
      metals.forEach(function (m) {
        m.addEventListener('change', function () {
          if (S.sizeQuiet || !m.checked) return;
          var prev = sizeLast;
          S.sizeAsk = false;
          if (m.dataset.na) {   // a Material the size doesn't come in: back to the size it has, said, with the way back
            setSize(Object.keys(m._sz)[0] || '');
            m.checked = true; fire(m);
            var back = byName(prev.metal), ok = !prev.ask && back && back !== m && back._sz[prev.size];
            say(tpl(SIZE.t.reverse, { material: m.dataset.metal }), ok ? tpl(SIZE.t.reverseUndo, { old_material: prev.metal }) : '', restore(prev.size, prev.metal));
          } else { say(''); paintSel(); }   // onMetal ran before this handler, while S.sizeAsk was still on
          remember();
        });
      });
      remember();
    })();

    /* ---------- breed picker ---------- */
    var q = $('[data-ph-bq]'), clear = $('[data-ph-bclear]'), empty = $('[data-ph-bempty]'), countEl = $('[data-ph-bcount]');
    var grid = $('[data-ph-bgrid]'), selName = $('[data-ph-bsel-name]'), selImg = $('[data-ph-bsel-img]'), change = $('[data-ph-bchange]');
    var field = $('[data-ph-bopen]'), baz = $('[data-ph-baz]'), sheet = $('[data-ph-bsheet]'), panel = $('[data-ph-bpanel]');
    var ball = $('[data-ph-ball]'), bindex = $('[data-ph-bindex]');
    if (sheet && field) root.classList.add('js-sheet');
    var code = $('[data-ph-bcode]'), bimg = $('[data-ph-bimg]'), msg = $('[data-ph-bmsg]');
    var index = tiles.map(function (t) { return norm(t.value + ' ' + (t.dataset.k || '')); });
    var initials = tiles.map(function (t) { return norm(t.value.split(' - ')[0]).split(' ').map(function (w) { return w[0]; }).join(''); });
    var ALIAS = {};   // "gsd = german shepherd" (section setting search_aliases)
    (C.aliases || []).forEach(function (l) { var p = String(l).split('='); if (p.length === 2 && norm(p[0])) ALIAS[norm(p[0])] = norm(p[1]); });
    var srTimer;
    function say(t) { clearTimeout(srTimer); srTimer = setTimeout(function () { if (countEl) countEl.textContent = t; }, 400); }
    function filter() {
      var v = norm(q.value), n = 0, custom = null, k = 0;
      var cap = !v && !S.showAll && !S.az && sheet && root.classList.contains('js-sheet') ? (+T.firstRows || 30) : Infinity;
      tiles.forEach(function (t, i) {
        if (t.dataset.slug === 'custom') { custom = t; return; }
        var al = ALIAS[v];
        var hit = !v || index[i].indexOf(v) !== -1 || (al && index[i].indexOf(al) !== -1) || (v.length > 1 && initials[i] === v.replace(/ /g, ''));
        if (hit && k >= cap && !t.checked) { t.parentNode.hidden = true; n++; k++; return; }   // beyond the first rows: "View all"
        t.parentNode.hidden = !hit; if (hit) { n++; k++; }
      });
      if (ball) ball.hidden = !(k > cap);
      $$('[data-ph-bletter]').forEach(function (h) {   // letter headers (A–Z mode): only above letters that have rows shown
        var any = $$('.ph-brow[data-l="' + h.dataset.phBletter + '"]').some(function (r) { return !r.hidden; });
        h.hidden = !!v || !any;
      });
      // "Mixed breed or not listed" stays reachable: shown with no query, on its own words, and whenever nothing matches
      var ownHit = !!(custom && v && index[tiles.indexOf(custom)].indexOf(v) !== -1);
      if (custom) custom.parentNode.hidden = !(!v || ownHit || !n);
      if (clear) clear.hidden = !q.value;
      if (empty) empty.textContent = n || ownHit ? '' : tpl(T.empty, { query: q.value.trim() });
      if (grid && v) grid.scrollTop = 0;
      if (v) say(tpl(T.resultsSr, { n: n }));
      var cl = $('[data-ph-bcountline]');   // QA r4 nit 1: "12 of 209 breeds" while a query is active
      if (cl) cl.textContent = v ? tpl(T.countFiltered, { n: n, count: tiles.length - (custom ? 1 : 0) }) : T.countLine;
    }
    if (q) {
      q.addEventListener('input', filter);
      q.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {   // never submit the form from the search box; jump to the first match instead
          e.preventDefault();
          var first = tiles.filter(function (t) { return !t.parentNode.hidden; })[0];
          if (first) first.focus();
        }
        if (e.key === 'ArrowDown') { var f = tiles.filter(function (t) { return !t.parentNode.hidden; })[0]; if (f) { e.preventDefault(); f.focus(); } }
        if (e.key === 'Escape' && q.value) { e.stopPropagation(); q.value = ''; filter(); }
      });
    }
    if (clear) clear.addEventListener('click', function () { q.value = ''; filter(); q.focus(); });
    function paintSel() {
      var b = breed(), fromPhoto = !b && hasPhoto();   // photo, no breed: "From your photo · Choose a breed (optional)"
      if (selName) selName.textContent = b ? b.value : fromPhoto ? T.fromPhotoSel : (T.fieldEmpty || T.breedNone);
      if (selImg) {
        if (b && !isCustom()) { selImg.src = sized(urlOf(b), 192); selImg.hidden = false; }
        else if (fromPhoto && S.photo && S.photo.ok) { selImg.src = S.photo.url; selImg.hidden = false; }
        else selImg.hidden = true;
      }
      if (change) change.textContent = fromPhoto ? T.fromPhotoChoose : (T.fieldSub || T.change);   // field sub-line
      var lg = $('[data-ph-blegend]'); if (lg && T.legendPhoto) lg.textContent = hasPhoto() ? T.legendPhoto : T.legend;
      root.classList.toggle('from-photo', fromPhoto);
      root.classList.toggle('has-breed', !!b);
      root.classList.toggle('is-custom', isCustom());
      if (code) code.value = b ? b.dataset.slug : '';   // empty values are dropped before posting
      if (bimg) bimg.value = b ? urlOf(b) : '';          // cart thumbnail (snippets/ph-cart-line-image)
      var st = $('[data-ph-st-name]');
      if (st) st.textContent = SINGLE ? (metal() ? metal().dataset.metal + (qty() > 1 ? ' \u00d7 ' + qty() : '') : '') : b ? b.value : fromPhoto ? T.fromPhotoSel : T.breedNone;   // P-062: "× 2" at qty 2
      if (st && SINGLE && window.PetalHushQB) { var qbs = window.PetalHushQB.sel(form, metal() ? metal().dataset.metal : '', qty()); if (qbs != null) st.textContent = qbs; }   // P-092b: "3.15 in · 3 pieces"
      if (st && SINGLE && SIZE && sizeRadios.length) st.textContent = (S.sizeAsk ? '' : (metal() ? metal().dataset.metal + ' \u00b7 ' : '')) + curSize() + (qty() > 1 ? ' \u00d7 ' + qty() : '');   // P-106: "Silver Plated · Large"
    }
    tiles.forEach(function (t) {
      t.addEventListener('change', function () {
        paintSel(); paintMain(); paintCustom(true);
        if (msg) msg.textContent = '';
        $('[data-ph-bpick]') && $('[data-ph-bpick]').removeAttribute('aria-invalid');
        say(tpl(T.selectedSr, { breed: t.value }));
        if (S.tried) showErrors(problems());
        syncUrl();
        if (window.matchMedia('(min-width: 900px)').matches) goTo(0);
      });
    });
    var pick = root.querySelector('.ph-bpick'); if (pick) pick.setAttribute('data-ph-bpick', '');
    /* ---------- the sheet ---------- */
    var opener = null, kbKey = null;
    function focusables() {
      return Array.prototype.filter.call(panel.querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])'), function (el) {
        if (el.disabled || el.closest('[hidden]')) return false;
        if (el.type === 'radio') return el.checked || !tiles.some(function (t) { return t.checked && !t.parentNode.hidden; }) && el === tiles.filter(function (t) { return !t.parentNode.hidden; })[0];
        return el.offsetParent !== null || el === q;
      });
    }
    function openSheet(az, btn) {
      if (!sheet || !root.classList.contains('js-sheet')) return;
      opener = btn || field;   // focus returns to the field (or Browse A–Z) on close
      S.az = !!az;
      sheet.classList.toggle('is-az', S.az);
      if (bindex) bindex.hidden = !S.az;
      sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true');
      sheet.classList.add('is-open');
      document.documentElement.classList.add('ph-lock');
      if (field) field.setAttribute('aria-expanded', 'true');
      filter();
      var b = breed();
      requestAnimationFrame(function () {
        if (grid) grid.scrollTop = b && !b.parentNode.hidden ? Math.max(0, b.parentNode.offsetTop - grid.offsetTop - 60) : 0;
        if (q) q.focus({ preventScroll: true });
      });
    }
    function closeSheet() {
      if (!sheet || !sheet.classList.contains('is-open')) return;
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('ph-lock');
      if (field) field.setAttribute('aria-expanded', 'false');
      if (q && q.value) { q.value = ''; }
      S.showAll = false; S.az = false; filter();
      (opener && document.body.contains(opener) ? opener : field).focus({ preventScroll: false });
    }
    if (field) { field.setAttribute('aria-expanded', 'false'); field.addEventListener('click', function () { openSheet(false, field); }); }
    if (baz) baz.addEventListener('click', function () { openSheet(true, baz); });
    $$('[data-ph-bclose]').forEach(function (x) { x.addEventListener('click', closeSheet); });
    if (ball) ball.addEventListener('click', function () {
      S.showAll = true; var first = tiles.filter(function (t) { return !t.parentNode.hidden; }).length; filter();
      var next = tiles.filter(function (t) { return !t.parentNode.hidden; })[first]; if (next) next.focus();
    });
    if (bindex) bindex.addEventListener('click', function (e) {
      var l = e.target.closest('[data-ph-bletter-go]'); if (!l) return;
      var h = $('[data-ph-bletter="' + l.dataset.phBletterGo + '"]'); if (h && grid) grid.scrollTop = h.offsetTop - grid.offsetTop - 4;
    });
    if (sheet) sheet.addEventListener('keydown', function (e) {
      if (!sheet.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); if (q && q.value) { q.value = ''; filter(); } else closeSheet(); return; }
      if (e.key === 'Tab') {   // focus trap
        var f = focusables(); if (!f.length) return;
        var i = f.indexOf(document.activeElement);
        if (e.shiftKey && (i <= 0)) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && (i === f.length - 1 || i === -1)) { e.preventDefault(); f[0].focus(); }
      }
    });
    // picking closes the sheet: a tap/click, Enter or Space. Arrow keys only move the choice (radio group behaviour).
    if (grid) {
      grid.addEventListener('keydown', function (e) {
        kbKey = e.key;
        if (e.key === 'Enter' && e.target.type === 'radio') { e.preventDefault(); if (!e.target.checked) { e.target.checked = true; e.target.dispatchEvent(new Event('change', { bubbles: true })); } closeSheet(); }
      });
      grid.addEventListener('click', function (e) {
        var r = e.target.closest('.ph-brow'); if (!r) return;
        var key = kbKey; kbKey = null;
        if (key && key.indexOf('Arrow') === 0) return;
        if (e.target.tagName === 'INPUT') setTimeout(closeSheet, 0);
      });
    }

    /* ---------- size chart: the size-guide gallery image in a native dialog ---------- */
    var sizeBtn = $('[data-ph-sizechart]'), sizeDlg = $('[data-ph-sizeguide]');
    if (sizeBtn && sizeDlg && sizeDlg.showModal) {
      sizeBtn.addEventListener('click', function () { sizeDlg.showModal(); });
      sizeDlg.addEventListener('click', function (e) { if (e.target === sizeDlg || e.target.closest('[data-ph-sizeclose]')) sizeDlg.close(); });
      sizeDlg.addEventListener('close', function () { sizeBtn.focus(); });
    } else if (sizeBtn) sizeBtn.hidden = true;

    /* ---------- photo: properties[Photo 1] (reference only) ---------- */
    var up = $('[data-ph-up="1"]');
    var P1 = PF ? { photo: null } : null;   // P-084: Photo 1 as the first-look source (PV), like a studio photo field
    var file = up && up.querySelector('input[type=file]'), upMsg = up && up.querySelector('.ph-msg');
    function setMsg(text, kind) {
      upMsg.className = 'ph-msg' + (kind ? ' is-' + kind : '');
      upMsg.textContent = text;
      file.setAttribute('aria-invalid', kind === 'err');
    }
    function paintUp() {
      var p = S.photo;
      up.classList.toggle('has-photo', !!p);
      up.querySelector('.ph-ic').innerHTML = p && p.ok ? '<img src="' + p.url + '" alt="">'
        : '<svg viewBox="0 0 24 24"><path d="M4 8h3l2-2.5h6L17 8h3v11H4z"/><circle cx="12" cy="13" r="3.5"/></svg>';
      up.querySelector('small').textContent = p ? p.name : T.uploadHint;
      up.querySelector('.ph-act').textContent = p ? T.replace : T.upload;
    }
    function handleFile(f) {
      var ext = (f.name.split('.').pop() || '').toLowerCase();
      var typeOk = /^image\/(jpeg|png|heic|heif|webp)$/.test(f.type);
      var reject = function (t) {   // QA R2: a rejected file never replaces a good one in the form
        var prev = S.photo && S.photo.file;
        keepFile(file, prev || null);
        setMsg(t, prev ? 'warn' : 'err');
        if (prev) file.setAttribute('aria-invalid', false);
      };
      if (FILE_EXT.indexOf(ext) === -1 && !typeOk) return reject(T.badType);
      if (f.size > C.maxMB * 1024 * 1024) return reject(tpl(T.tooBig, { mb: C.maxMB }));
      phUpDrop(file.name);   // P-102b: the old photo's upload stops
      if (S.photo) URL.revokeObjectURL(S.photo.url);
      var url = URL.createObjectURL(f);   // preview only; the file posts with the form
      S.photo = { url: url, name: f.name, ok: false, file: f };
      if (PV && P1) { P1.photo = S.photo; PV.reset(P1); }   // P-084: a new photo drops the old first look
      setMsg(T.adding, '');
      var probe = new Image();
      probe.onload = function () {
        if (!S.photo || S.photo.url !== url) return;
        S.photo.ok = true;
        phPhotoEvent('photo_1');
        phSlimStart(S.photo, probe, C);   // P-102: the smaller copy for the bag
        phUpStart(S.photo, probe, C, file.name);   // P-102b: pre-upload
        if (probe.naturalWidth < C.minPx || probe.naturalHeight < C.minPx) setMsg(T.tooSmall, 'warn'); else setMsg(T.added, '');
        paintUp(); update();
        if (PV && P1) PV.start(P1);   // P-084: a valid, decodable photo starts the first look
      };
      probe.onerror = function () { if (!S.photo || S.photo.url !== url) return; setMsg(T.noPreview, ''); paintUp(); update(); };
      probe.src = url;
      paintUp(); update();
    }
    if (up) {
      var drop = up.querySelector('.ph-drop');
      file.addEventListener('change', function () { if (file.files[0]) handleFile(file.files[0]); });
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); }); });
      drop.addEventListener('drop', function (e) { var f = e.dataTransfer.files[0]; if (!f) return; keepFile(file, f); handleFile(f); });
      up.querySelector('.ph-rm').addEventListener('click', function () {
        phUpDrop(file.name);   // P-102b
        if (S.photo) URL.revokeObjectURL(S.photo.url);
        S.photo = null; file.value = '';
        if (PV && P1) { P1.photo = null; PV.reset(P1); }   // P-084
        paintUp(); setMsg('', ''); update(); file.focus();
      });
    }

    /* ---------- photo sculpt box; "Mixed breed or not listed" ticks and locks it ---------- */
    var photoOn = $('[data-ph-photo-on]'), photoWrap = $('[data-ph-photo-wrap]'), photoReq = $('[data-ph-photo-req]');
    var photoHelp = $('[data-ph-photo-help]'), photoEmpty = $('[data-ph-photo-empty]');
    var pfOpt = $('[data-ph-pf-opt]'), pfRet = $('[data-ph-pf-ret]');
    function paintPF() {   // P-084: optional upload; Mixed breed = required (marker swap, help swap)
      var c = isCustom(), has = hasPhoto();
      if (file) { file.required = c; file.setAttribute('aria-required', c ? 'true' : 'false'); }
      if (photoReq) photoReq.hidden = !c;
      if (pfOpt) pfOpt.hidden = c;
      if (photoEmpty) photoEmpty.hidden = has || c;
      if (pfRet) pfRet.hidden = !has;
      if (photoHelp) photoHelp.innerHTML = fmt(c && PF.helpMixed ? PF.helpMixed : PF.help);
      if (!c && upMsg && upMsg.textContent === T.photoRequired) setMsg('', '');
    }
    function paintPhotoBox() {
      if (PF) return paintPF();
      if (!photoOn) return;
      var c = isCustom(), on = photoOn.checked;
      if (photoWrap) photoWrap.hidden = !on;
      if (file) { file.disabled = !on; file.required = on; }   // disabled inputs don't post
      if (photoEmpty) photoEmpty.hidden = on || c;
      if (photoReq) photoReq.hidden = !c;
      photoOn.setAttribute('aria-disabled', c ? 'true' : 'false');
      if (photoHelp) photoHelp.innerHTML = fmt(c ? T.photoHelpMixed : T.photoHelp);
      if (!on && upMsg && (upMsg.textContent === T.photoMissing || upMsg.textContent === T.photoRequired)) setMsg('', '');
    }
    function paintCustom(user) {
      if (photoOn && isCustom()) photoOn.checked = true;   // mixed breed needs the photo: ticked and locked
      paintPhotoBox();
      if (user) update();
    }
    if (photoOn) photoOn.addEventListener('change', function () {
      if (isCustom() && !photoOn.checked) { photoOn.checked = true; say(T.photoRequired); }   // locked
      paintPhotoBox();
      if (photoOn.checked && file && !S.photo) file.focus();
      update();
    });

    /* ---------- back message ---------- */
    var back = $('[data-ph-back]'), backField = $('[data-ph-role="back"] input');
    function labelOf(el) { var l = el.labels && el.labels[0]; return l ? l.firstChild.textContent.trim() : ''; }
    if (backField) {
      var max = +backField.maxLength, cnt = root.querySelector('[data-ph-count-of="' + backField.id + '"]'), bmsg = document.getElementById(backField.id + '-msg');
      var sync = function (speak) {
        var len = Array.from(backField.value).length, left = max - len;
        cnt.textContent = len + '/' + max;
        cnt.classList.toggle('is-lim', left <= 0);
        var err = !ALLOWED.test(backField.value) ? T.charset : '';
        bmsg.textContent = err;
        backField.setAttribute('aria-invalid', !!err);
        if (speak && !err) {
          if (left === 0) say(tpl(T.limitReached, { max: max }));
          else if (left <= 3) say(tpl(T.charsLeft, { n: left }));
        }
      };
      backField.addEventListener('input', function () { sync(true); update(); });
      sync(false);
    }
    if (back) back.addEventListener('change', function () {
      S.back = back.checked;
      var wrap = $('[data-ph-back-wrap]');
      wrap.hidden = !back.checked; backField.disabled = !back.checked;   // disabled fields don't post
      if (back.checked) backField.focus();
      update();
    });

    /* ---------- free text fields (P-041, single design): e.g. the names on a quote watch ---------- */
    var TX = C.text || {};
    var texts = SINGLE && C.text ? $$('[data-ph-role="text"] input') : [];
    var TXRE = TX.set === 'engrave' ? ALLOWED : NAMES;
    // QA N5/N6: the limit, the counter and the check use the value trimmed and in NFC (an accent pasted from macOS is
    // decomposed). The browser's maxlength (raw UTF-16 units) only stays as a loose ceiling; the real limit is enforced
    // here by undoing an edit that would go over it, as maxlength would. Without JS, maxlength = the limit (Liquid).
    function tval(f) { return f.value.normalize('NFC').trim(); }
    function tlen(f) { return Array.from(tval(f)).length; }
    texts.forEach(function (f) {
      var max = +f.maxLength, cnt = root.querySelector('[data-ph-count-of="' + f.id + '"]'), tmsg = document.getElementById(f.id + '-msg');
      f.dataset.max = max; f.maxLength = max * 2 + 2;
      var prev = { v: f.value, s: 0, e: 0 };
      f.addEventListener('beforeinput', function () { prev = { v: f.value, s: f.selectionStart, e: f.selectionEnd }; });
      var sync = function (speak) {
        var len = tlen(f), left = max - len;
        cnt.textContent = len + '/' + max;
        cnt.classList.toggle('is-lim', left <= 0);
        var err = !TXRE.test(f.value.normalize('NFC')) ? (TX.charset || T.charset) : '';
        tmsg.textContent = err;
        f.setAttribute('aria-invalid', !!err);
        if (speak && !err) {
          if (left === 0) say(tpl(T.limitReached, { max: max }));
          else if (left <= 3) say(tpl(T.charsLeft, { n: left }));
        }
      };
      f.addEventListener('input', function () {
        if (tlen(f) > max && Array.from(prev.v.normalize('NFC').trim()).length <= max) {   // over the limit: undo this edit
          f.value = prev.v; try { f.setSelectionRange(prev.s, prev.e); } catch (e) { /* not focused */ }
          say(tpl(T.limitReached, { max: max }));
        }
        prev = { v: f.value, s: f.selectionStart, e: f.selectionEnd };   // last good value (browsers without beforeinput)
        sync(true); update();
      });
      f.addEventListener('change', function () { var v = tval(f); if (v !== f.value) { f.value = v; sync(false); update(); } });   // tidy on blur
      sync(false);
    });

    /* ---------- P-045 Souly studio fields (C.studio): custom.personalize ---------- */
    var SZ = SINGLE && C.studio ? C.studio : null;
    var pzPhotos = [];
    var CAM = '<svg viewBox="0 0 24 24"><path d="M4 8h3l2-2.5h6L17 8h3v11H4z"/><circle cx="12" cy="13" r="3.5"/></svg>';
    function pzBoxes() { return SZ ? $$('[data-ph-pz-field]') : []; }
    function pzVal(inp) { var v = inp.value.normalize('NFC').trim(); if (inp.dataset.charset === 'strict') v = v.replace(/[\u2018\u2019]/g, "'"); return /^initials?$/.test(inp.dataset.type || '') ? v.toUpperCase() : v; }   // P-113b S3: strict = curly apostrophe -> '
    function pzByInput(inp) { return pzPhotos.filter(function (P) { return P.input === inp; })[0] || null; }
    function pzPhoto(upEl) {   // one studio photo field: same checks as Photo 1 (handleFile), its own state
      var inp = upEl.querySelector('input[type=file]'), m = upEl.querySelector('.ph-msg');
      var P = { input: inp, photo: null };
      P.msg = function (text, kind) { m.className = 'ph-msg' + (kind ? ' is-' + kind : ''); m.textContent = text; inp.setAttribute('aria-invalid', kind === 'err'); };
      P.has = function () { return !!(P.photo && !inp.disabled && inp.files && inp.files.length); };
      function paint() {
        var p = P.photo;
        upEl.classList.toggle('has-photo', !!p);
        upEl.querySelector('.ph-ic').innerHTML = p && p.ok ? '<img src="' + p.url + '" alt="">' : CAM;
        upEl.querySelector('small').textContent = p ? p.name : T.uploadHint;
        upEl.querySelector('.ph-act').textContent = p ? T.replace : T.upload;
      }
      function take(f) {
        var ext = (f.name.split('.').pop() || '').toLowerCase();
        var typeOk = /^image\/(jpeg|png|heic|heif|webp)$/.test(f.type);
        var reject = function (t) {   // a rejected file never replaces a good one in the form
          var prev = P.photo && P.photo.file;
          keepFile(inp, prev || null);
          P.msg(t, prev ? 'warn' : 'err');
          if (prev) inp.setAttribute('aria-invalid', false);
        };
        if (FILE_EXT.indexOf(ext) === -1 && !typeOk) return reject(T.badType);
        if (f.size > C.maxMB * 1024 * 1024) return reject(tpl(T.tooBig, { mb: C.maxMB }));
        phUpDrop(inp.name);   // P-102b: the old photo's upload stops
        if (P.photo) URL.revokeObjectURL(P.photo.url);
        var url = URL.createObjectURL(f);   // preview only; the file posts with the form
        P.photo = { url: url, name: f.name, ok: false, file: f };
        if (PV) PV.reset(P);   // P-048: a new photo drops the old AI preview job
        P.msg(T.adding, '');
        var probe = new Image();
        probe.onload = function () {
          if (!P.photo || P.photo.url !== url) return;
          P.photo.ok = true;
          phPhotoEvent('studio_photo');
          phSlimStart(P.photo, probe, C);   // P-102
          phUpStart(P.photo, probe, C, P.input.name);   // P-102b
          if (probe.naturalWidth < C.minPx || probe.naturalHeight < C.minPx) P.msg(T.tooSmall, 'warn'); else P.msg(T.added, '');
          paint(); update();
          if (PV) PV.start(P);   // P-048: a valid, decodable photo starts the AI preview (first photo field only)
        };
        probe.onerror = function () { if (!P.photo || P.photo.url !== url) return; P.msg(T.noPreview, ''); paint(); update(); };
        probe.src = url;
        paint(); update();
      }
      var drop = upEl.querySelector('.ph-drop');
      inp.addEventListener('change', function () { if (inp.files[0]) take(inp.files[0]); else if (P.photo) keepFile(inp, P.photo.file); });
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); }); });
      drop.addEventListener('drop', function (e) { var f = e.dataTransfer.files[0]; if (!f || inp.disabled) return; keepFile(inp, f); take(f); });
      upEl.querySelector('.ph-rm').addEventListener('click', function () {
        phUpDrop(inp.name);   // P-102b
        if (P.photo) URL.revokeObjectURL(P.photo.url);
        P.photo = null; inp.value = '';
        if (PV) PV.reset(P);   // P-048
        paint(); P.msg('', ''); update(); inp.focus();
      });
      return P;
    }
    /* ---------- P-048 AI preview (C.preview, studio only); P-066 loading pill, _Preview job, ph_pv_jobs ---------- */
    var PV = (SZ || PF) && C.preview && C.preview.start && C.preview.status && C.preview.turnstile_sitekey && window.fetch && window.FormData ? pvMake(C.preview) : null;
    function pvMake(cfg) {
      /* P-111 S3: poll every 2 s for the first 40 s (FAST_FOR) of visible polling, then every 4 s; at most 4 min of visible time */
      var t = cfg.t || {}, EVERY = 4000, FAST = 2000, FAST_FOR = 40000, CAP = 240000;
      var gateOpen = null, early = null;   // P-111 S1: opens the current photo's pvGate; S2: the intent token {p, at}
      /* P-111 end */
      var job = 0, ctl = null, timer = null, resume = null, wrap = null, box = null, sr = null, btn = null, prop = null, jprop = null;
      var tsP = null, tsBox = null, tsId = null, bidMem = '', tick = null, cur = null, added = {};
      var LIVE = window.PetalHushPvLive = window.PetalHushPvLive || {};   // jobs this page polls itself (the cart writer leaves them alone)
      var TX = { title: t.title || '', note: t.note || '', alt: t.alt || '' };   // the cart dialog reuses this product's strings
      function first(P) { return P === (pzPhotos[0] || P1); }   // P-084: Photo 1 when there is no studio photo field
      function rnd() { return Math.random().toString(36).slice(2, 10); }
      function bid() {   // one random id per browser (limits per browser per day, server side)
        var make = function () { return window.crypto && crypto.randomUUID ? crypto.randomUUID() : 'b' + Date.now().toString(36) + rnd(); };
        try { var b = localStorage.getItem('ph_bid'); if (!b) { b = make(); localStorage.setItem('ph_bid', b); } return b; }
        catch (e) { return bidMem || (bidMem = make()); }
      }
      /* P-066 job store: localStorage ph_pv_jobs = { <id or client ref>: {t0, status, url, pid, t, ref, id} }, newest 12, < 24 h */
      function rec(c, patch) {
        try {
          var m = JSON.parse(localStorage.getItem('ph_pv_jobs') || '{}'), now = Date.now();
          if (!m || typeof m !== 'object' || Array.isArray(m)) m = {};
          [c.ref, c.id].forEach(function (k) {
            if (!k) return;
            var r = m[k] && typeof m[k] === 'object' ? m[k] : { t0: c.t0, pid: cfg.product_id == null ? null : cfg.product_id, t: TX, ref: c.ref };
            if (c.id) r.id = c.id;
            for (var p in patch) r[p] = patch[p];
            m[k] = r;
          });
          var out = {};
          Object.keys(m).filter(function (k) { return m[k] && typeof m[k].t0 === 'number' && now - m[k].t0 < 864e5; })
            .sort(function (a, b) { return m[b].t0 - m[a].t0; }).slice(0, 12).forEach(function (k) { out[k] = m[k]; });
          localStorage.setItem('ph_pv_jobs', JSON.stringify(out));
        } catch (e) { /* storage off or full: the cart falls back to "now" */ }
      }
      function tell(status, c, url) {   // for snippets/ph-cart-preview (same page)
        try { document.dispatchEvent(new CustomEvent('ph:pv:job', { detail: { ref: c.ref, id: c.id || '', status: status, url: url || '' } })); } catch (e) { /* old browser */ }
      }
      function unlive(c) { if (c) { delete LIVE[c.ref]; if (c.id) delete LIVE[c.id]; } }
      function say(text) { if (sr) sr.textContent = text || ''; }
      function onVis() { if (!document.hidden && resume) { var r = resume; resume = null; document.removeEventListener('visibilitychange', onVis); r(); } }
      function stop() { clearTimeout(timer); timer = null; resume = null; clearInterval(tick); tick = null; document.removeEventListener('visibilitychange', onVis); }
      function dropProps() {
        [prop, jprop].forEach(function (x) { if (x && x.parentNode) x.parentNode.removeChild(x); });
        prop = null; jprop = null;
      }
      function hidden(name, value) {
        var x = document.createElement('input');
        x.type = 'hidden'; x.name = 'properties[' + name + ']'; x.value = value; x.setAttribute('data-ph-pv-prop', '');
        form.appendChild(x);
        return x;
      }
      function clear() {   // forget the job: abort requests (unless it is in the bag), hide the pill, drop _Preview / _Preview job
        job++;
        if (gateOpen) gateOpen();   // P-111 S1: a waiting pre-upload of the old photo is not held any longer
        var c = cur; cur = null;
        if (ctl && !(c && added[c.ref])) { try { ctl.abort(); } catch (e) { /* already done */ } }
        ctl = null;
        stop(); unlive(c);
        if (c && c.status === 'pending' && added[c.ref]) tell('released', c);   // the cart writer finishes it
        if (box) { box.innerHTML = ''; box.className = 'ph-pv-box'; }
        say('');
        btn = null;
        dropProps();
      }
      /* progress, from the job's start time: ease-out to 90 % at 30 s, then a slow crawl toward 97 % (never 100 until done).
         Reduced motion: 10 % steps, no transition. */
      function pct(ms) {
        var s = Math.max(0, ms) / 1000;
        var p = s <= 30 ? 90 * (1 - Math.pow(1 - s / 30, 3)) : 90 + 7 * (1 - Math.exp(-(s - 30) / 90));
        return reduced ? Math.floor(p / 10) * 10 : p;
      }
      function paintBar(c) {
        var f = box && box.querySelector('.ph-pv-fill');
        if (f && c) f.style.transform = 'scaleX(' + (pct(Date.now() - c.t0) / 100).toFixed(4) + ')';
      }
      function showLoading(c) {
        var hid = 'ph-pv-h-' + rnd();
        box.className = 'ph-pv-box is-loading';
        box.innerHTML = '<div class="ph-pv-btn" data-ph-pv-btn' + (t.hint ? ' aria-describedby="' + hid + '"' : '') + '>'
          + '<span class="ph-pv-lbl">' + esc(t.loading || t.title) + '</span><span class="ph-pv-bar" aria-hidden="true"><span class="ph-pv-fill"></span></span></div>'
          + (t.hint ? '<p class="ph-pv-hint" id="' + hid + '">' + esc(t.hint) + '</p>' : '');
        btn = box.querySelector('[data-ph-pv-btn]');   // the loading pill (not a button any more: nothing to click)
        say(t.loadingSr);
        paintBar(c);
        tick = setInterval(function () { paintBar(c); }, reduced ? 1000 : 250);
      }
      function ready(url, my) {   // fill the bar, then the first look shows inline, right under the photo tile (no button, no pop-up)
        if (my !== job || !cur) return;
        clearInterval(tick); tick = null;
        cur.url = url;
        prop = hidden('_Preview', url);
        var f = box.querySelector('.ph-pv-fill'); if (f) f.style.transform = 'scaleX(1)';
        var swap = function () {
          if (my !== job || !btn) return;
          btn = null;
          box.className = 'ph-pv-box is-ready';
          box.innerHTML = '<figure class="ph-pv-fig">'
            + (t.title ? '<figcaption class="ph-pv-cap">' + fmt(t.title) + '</figcaption>' : '')
            + '<img class="ph-pv-img" width="1024" height="1024" alt="' + esc(t.alt || '') + '" decoding="async">'
            + '<p class="ph-pv-err" hidden>' + fmt(t.imgError) + '</p></figure>';
          var im = box.querySelector('.ph-pv-img'), er = box.querySelector('.ph-pv-err');
          im.addEventListener('error', function () { im.hidden = true; er.hidden = !t.imgError; });   // e.g. the render expired
          im.src = url;   // already preloaded by reveal()
          say(t.readySr);
        };
        if (reduced) swap(); else setTimeout(swap, 400);
      }
      function fail(my) {   // failed / off / timeout / network error / broken image: one quiet line, the photo stays
        if (my !== job || !cur) return;
        var c = cur;
        stop(); unlive(c);
        c.status = 'failed'; rec(c, { status: 'failed' }); tell('failed', c);
        dropProps();
        btn = null;
        if (!t.fail) { box.innerHTML = ''; box.className = 'ph-pv-box'; say(''); return; }
        box.className = 'ph-pv-box is-failed';
        box.innerHTML = '<p class="ph-pv-fail">' + esc(t.fail) + '</p>';
        say(t.fail);
      }
      function shrink(f) {   // longest side <= 2048 px, JPEG q 0.85 (EXIF orientation applied by the browser)
        return new Promise(function (res) {
          var u = URL.createObjectURL(f), im = new Image();
          im.onload = function () {
            var w = im.naturalWidth, h = im.naturalHeight, k = Math.min(1, 2048 / Math.max(w, h, 1));
            var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(h * k));
            var g = c.getContext('2d'); g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height); g.drawImage(im, 0, 0, c.width, c.height);
            URL.revokeObjectURL(u);
            if (c.toBlob) c.toBlob(function (b) { res(b); }, 'image/jpeg', 0.85); else res(null);
          };
          im.onerror = function () { URL.revokeObjectURL(u); res(null); };
          im.src = u;
        });
      }
      function loadTs() {   // Cloudflare Turnstile, loaded only when a site key is set and a photo is chosen (P-111 S2: or on intent)
        if (window.turnstile) return Promise.resolve(window.turnstile);
        if (!tsP) tsP = new Promise(function (res, rej) {
          /* P-111 S2: ph-photo-up.js may have added the script already: wait for it instead of loading it twice */
          if (document.querySelector('script[src*="challenges.cloudflare.com/turnstile/"]')) {
            var t0 = Date.now();
            return (function wait() {
              if (window.turnstile) return res(window.turnstile);
              if (Date.now() - t0 > 20000) { tsP = null; return rej(); }
              setTimeout(wait, 100);
            })();
          }
          /* P-111 end */
          var sc = document.createElement('script');
          sc.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'; sc.async = true;
          sc.onload = function () { if (window.turnstile) res(window.turnstile); else { tsP = null; rej(); } };
          sc.onerror = function () { tsP = null; rej(); };
          document.head.appendChild(sc);
        });
        return tsP;
      }
      function token() {   // one fresh invisible token per request ('' = none)
        var key = cfg.turnstile_sitekey; if (!key) return Promise.resolve('');
        return loadTs().then(function (ts) {
          return new Promise(function (res) {
            var to = setTimeout(function () { res(''); }, 20000);
            var done = function (v) { clearTimeout(to); res(v || ''); };
            if (tsBox) { try { ts.remove(tsId); } catch (e) { /* gone */ } if (tsBox.parentNode) tsBox.parentNode.removeChild(tsBox); }
            tsBox = document.createElement('div'); tsBox.className = 'ph-pv-ts'; root.appendChild(tsBox);
            try { tsId = ts.render(tsBox, { sitekey: key, appearance: 'interaction-only', callback: done, 'error-callback': function () { done(''); }, 'expired-callback': function () { done(''); } }); }
            catch (e) { done(''); }
          });
        }).catch(function () { return ''; });
      }
      /* P-111 S2: the intent token, if fresh (< 4 min; Turnstile tokens live 5 min, single use), else a new one */
      function tokenFor() {
        var e = early; early = null;
        if (!e || (e.at && Date.now() - e.at > 240000)) return token();
        return e.p.then(function (v) { return v && Date.now() - e.at <= 240000 ? v : token(); });
      }
      function warm() {   // first tap / focus / drag on the photo field: script + one token, before the photo is picked
        if (early || cur || !cfg.turnstile_sitekey) return;   // QA m1: a job already running owns the widget
        var e = early = { at: 0, p: null };
        e.p = token().then(function (v) { e.at = Date.now(); return v; });
      }
      /* P-111 end */
      function json(r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); }
      function reveal(url, my, c) {   // preload first: a broken image never shows
        if (!/^(https:\/\/|\/(?!\/))/.test(url)) {
          if (my === job) return fail(my);
          c.status = 'failed'; rec(c, { status: 'failed' }); tell('failed', c); return;
        }
        var im = new Image();
        im.onload = function () {
          c.status = 'done'; rec(c, { status: 'done', url: url }); unlive(c); tell('done', c, url);
          if (my === job) ready(url, my);
        };
        im.onerror = function () {
          if (my === job) return fail(my);
          c.status = 'failed'; rec(c, { status: 'failed' }); tell('failed', c);
        };
        im.src = url;
      }
      function poll(c, my, sig, n, errs) {   // errs = consecutive transient errors (5xx, network): 2 are retried, the 3rd fails (QA nit)
        errs = errs || 0;
        if (my !== job) return;
        if (n >= CAP) return fail(my);   // timeout (P-111 S3: n = ms of visible polling, was a poll count)
        var wait = n < FAST_FOR ? FAST : EVERY;   // P-111 S3
        if (document.hidden) { resume = function () { poll(c, my, sig, n, errs); }; document.addEventListener('visibilitychange', onVis); return; }
        timer = setTimeout(function () {
          if (my !== job) return;
          if (document.hidden) return poll(c, my, sig, n, errs);   // hidden while waiting: pause, ask again once visible
          fetch(cfg.status + '?id=' + encodeURIComponent(c.id), { signal: sig, credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
            .then(json).then(function (j) {
              if (my !== job) return;
              var st = j && j.status;
              if (st === 'done' && j.url) reveal(String(j.url), my, c);
              else if (st === 'pending') poll(c, my, sig, n + wait, 0);   // P-111 S3
              else fail(my);   // failed, off, anything else
            }, function () {
              if (my !== job) return;   // aborted by Replace / Remove
              if (errs + 1 >= 3) fail(my); else poll(c, my, sig, n + wait, errs + 1);   // P-111 S3
            });
        }, wait);   // P-111 S3
      }
      function start(P) {
        if (!first(P) || !P.photo || !P.photo.file) return;
        clear();
        var my = job, c = cur = { ref: 'c-' + rnd(), id: '', t0: Date.now(), status: 'pending', url: '' };
        var keep = function () { return my === job || !!added[c.ref]; };   // already in the bag: finish the request for the cart
        ctl = window.AbortController ? new AbortController() : null;
        var sig = ctl ? ctl.signal : undefined;
        LIVE[c.ref] = true;
        jprop = hidden('_Preview job', c.ref);   // the client ref until /start answers with the job id
        rec(c, { status: 'pending' });
        showLoading(c);
        /* P-111 S1: the pre-upload of this photo (ph-photo-up.js) waits for this to open */
        var gr = null;
        P.photo.pvGate = new Promise(function (r) { gr = r; });
        var open = gateOpen = function () { if (gateOpen === open) gateOpen = null; gr(); };
        /* P-111 end */
        shrink(P.photo.file).then(function (blob) {
          if (!keep() || !blob) throw new Error('skip');
          return tokenFor().then(function (tok) {   // P-111 S2: tokenFor() = the intent token when fresh
            if (!keep() || (cfg.turnstile_sitekey && !tok)) throw new Error('skip');
            var fd = new FormData();
            fd.append('photo', blob, 'photo.jpg');
            fd.append('product_id', String(cfg.product_id == null ? '' : cfg.product_id));
            fd.append('bid', bid());
            if (tok) fd.append('turnstile', tok);
            return fetch(cfg.start, { method: 'POST', body: fd, signal: sig, credentials: 'same-origin', headers: { Accept: 'application/json' } });
          });
        }).then(function (r) { open(); return json(r); }).then(function (j) {   // P-111 S1: /start answered
          if (!keep()) return;
          var st = j && j.status;
          if (st === 'done' && j.url) {
            if (j.id) { c.id = String(j.id); if (my === job && jprop) jprop.value = c.id; }
            reveal(String(j.url), my, c);
          } else if (j && j.id && (!st || st === 'pending')) {
            c.id = String(j.id); rec(c, { status: 'pending' });
            if (my === job) { if (jprop) jprop.value = c.id; LIVE[c.id] = true; poll(c, my, sig, 0); }
            else tell('released', c);   // replaced after Add to bag: the cart writer polls it
          } else throw new Error('off');   // off (cap / limits), failed
        }).catch(function () {
          open();   // P-111 S1: failed or skipped
          if (my === job) return fail(my);
          if (added[c.ref] && c.status === 'pending') { c.status = 'failed'; rec(c, { status: 'failed' }); unlive(c); tell('failed', c); }
        });
      }
      var P0 = $('[data-ph-pz-up]'), box0 = P0 && P0.closest('[data-ph-pz-field]');
      if (!P0 && P1) { P0 = $('[data-ph-up="1"]'); box0 = P0 && P0.closest('[data-ph-photo-box]'); }   // P-084: under Photo 1
      if (!box0) return null;
      wrap = document.createElement('div');
      wrap.className = 'ph-pv'; wrap.setAttribute('data-ph-pv', '');
      sr = document.createElement('p');   // the live region exists before anything is announced
      sr.className = 'ph-sr-only'; sr.setAttribute('role', 'status'); sr.setAttribute('aria-live', 'polite'); sr.setAttribute('data-ph-pv-sr', '');
      box = document.createElement('div');
      box.className = 'ph-pv-box'; box.setAttribute('data-ph-pv-box', '');
      wrap.appendChild(sr); wrap.appendChild(box);
      var ups = P0.closest('.ph-uploaders') || P0;
      ups.parentNode.insertBefore(wrap, ups.nextSibling);   // right under the photo tile
      /* P-111 S2: intent on the first photo field (tap, focus, drag) loads Turnstile; nothing on page load */
      var INTENT = ['pointerdown', 'touchstart', 'focusin', 'dragenter'];
      var onIntent = function () {
        INTENT.forEach(function (ev) { box0.removeEventListener(ev, onIntent, true); });
        warm();
      };
      INTENT.forEach(function (ev) { box0.addEventListener(ev, onIntent, ev === 'touchstart' ? { capture: true, passive: true } : true); });
      /* P-111 end */
      return {
        start: function (P) { if (first(P)) start(P); },
        reset: function (P) { if (first(P)) clear(); },
        added: function () { if (!cur) return null; added[cur.ref] = true; return cur.ref; },   // Add to bag is posting this job: a Replace no longer aborts it
        unadd: function (ref) { if (ref) delete added[ref]; }   // QA nit: the add failed, so the job isn't in the bag after all
      };
    }
    if (SZ) {
      $$('[data-ph-pz-up]').forEach(function (u) { pzPhotos.push(pzPhoto(u)); });
      pzBoxes().forEach(function (box) {
        var inp = box.querySelector('input[type=text]'); if (!inp) return;
        var max = +inp.maxLength, cnt = root.querySelector('[data-ph-count-of="' + inp.id + '"]'), tmsg = document.getElementById(inp.id + '-msg');
        var sync = function () {
          var len = Array.from(inp.value).length;
          if (cnt) { cnt.textContent = len + '/' + max; cnt.classList.toggle('is-lim', len >= max); }
          if (tmsg) tmsg.textContent = '';
          inp.setAttribute('aria-invalid', false);
        };
        inp.addEventListener('input', function () {
          if (inp.dataset.charset === 'strict' && /[\u2018\u2019]/.test(inp.value)) { var s0 = inp.selectionStart, e0 = inp.selectionEnd; inp.value = inp.value.replace(/[\u2018\u2019]/g, "'"); try { inp.setSelectionRange(s0, e0); } catch (e) { /* not focusable */ } }   // P-113b S3
          sync(); update();
        });
        inp.addEventListener('change', function () { var v = pzVal(inp); if (v !== inp.value) { inp.value = v; sync(); update(); } });   // tidy on blur
        sync();
      });
      var pzCount = $('[data-ph-pz-count]');
      var applyCount = function () {   // "how many figures": only the first N repeated fields show and post
        var n = pzCount ? +pzCount.value : Infinity;
        $$('[data-ph-pz-field][data-rep]').forEach(function (box) {
          var off = +box.dataset.rep > n, inp = box.querySelector('input');
          box.hidden = off; if (inp) inp.disabled = off;
        });
      };
      if (pzCount) { pzCount.addEventListener('change', function () { applyCount(); update(); }); applyCount(); }
    }
    function pzProblems(out) {
      pzBoxes().forEach(function (box) {
        var kind = box.dataset.phPzField, inp = box.querySelector('input');
        if (box.hidden || !inp || inp.disabled) return;
        var label = box.dataset.label;
        if (kind === 'photo') {
          var P = pzByInput(inp);
          if (inp.required && !(P && P.has())) out.push({ id: inp.id, kind: 'pzphoto', t: tpl(SZ.photoMissing, { label: label }) });
          return;
        }
        var v = pzVal(inp), max = +inp.maxLength, bad = '';
        if (!v) { if (inp.required) out.push({ id: inp.id, kind: 'pztext', t: tpl(SZ.missing, { label: label }) }); return; }
        if (kind === 'year' && !/^\d{4}$/.test(v)) bad = SZ.year;
        else if (kind === 'number' && !/^\d+$/.test(v)) bad = tpl(SZ.number, { max: max });
        else if ((kind === 'initial' || kind === 'initials') && !/^[A-Za-z]+$/.test(v)) bad = tpl(SZ.initial, { max: max });
        else if (inp.dataset.charset === 'strict') { if (!STRICT.test(v)) bad = T.charset; }   // P-113b S3: the field's strict engraving set
        else if (kind === 'text' && max > 20) { if (/[\p{Extended_Pictographic}\p{Cc}<>{}\[\]]/u.test(v)) bad = SZ.note; }   // a note (e.g. "Which two"), not cast: punctuation ok, no emoji
        else if (!ALLOWED.test(v)) bad = T.charset;   // short text = cast / engraved: the engraving set
        if (bad) out.push({ id: inp.id, kind: 'pzbad', inline: bad, t: tpl(T.checkChars, { label: label }) });
      });
    }
    function pzNamed() {   // a studio field that will post makes the piece personalized (returns line)
      return pzBoxes().some(function (box) {
        var inp = box.querySelector('input'); if (box.hidden || !inp || inp.disabled) return false;
        return inp.required || (inp.type === 'file' ? !!(inp.files && inp.files.length) : !!inp.value.trim());
      });
    }

    /* ---------- validation ---------- */
    function problems() {
      var out = [];
      if (!SINGLE && !breed() && !hasPhoto()) out.push({ id: field ? field.id : (q ? q.id : ''), kind: 'breed', t: T.breedErr });   // a photo alone is enough (founder 2026-10-10)
      if (SINGLE) texts.forEach(function (f) {   // P-041: in page order, so focus lands on the first bad field
        if (!TXRE.test(f.value.normalize('NFC'))) out.push({ id: f.id, t: tpl(T.checkChars, { label: f.dataset.label }) });
        else if (f.required && !tval(f)) out.push({ id: f.id, kind: 'text', t: tpl(TX.missing, { label: f.dataset.label }) });
      });
      if (SZ) pzProblems(out);   // P-045 studio fields, in page order
      if (photoWanted() && !hasPhoto() && file) out.push({ id: file.id, kind: 'photo', t: isCustom() ? T.photoRequired : T.photoMissing });
      if (PF && isCustom() && !hasPhoto() && file) out.push({ id: file.id, kind: 'photo', t: T.photoRequired });   // P-084: Mixed breed needs the photo
      if (SIZE && S.sizeAsk) out.push({ id: metals[0] ? metals[0].id || '' : '', t: SIZE.t.ask });   // P-106: Large + "ask": a material first
      var m = metal(); if (!S.sizeAsk && (!m || m.disabled)) out.push({ id: m ? m.id || '' : '', t: T.unavailable });
      if (backField && !backField.disabled) {
        if (!ALLOWED.test(backField.value)) out.push({ id: backField.id, t: tpl(T.checkChars, { label: labelOf(backField) }) });
        else if (!backField.value.trim()) out.push({ id: backField.id, kind: 'back', t: T.backMissing });
      }
      return out;
    }
    function showErrors(list) {
      var box = $('[data-ph-error]');
      if (!list.length) { box.innerHTML = ''; return; }
      box.innerHTML = '<b>' + esc(T.errHeading) + '</b><ul>' + list.map(function (p) { return '<li><a href="#' + esc(p.id) + '" data-focus="' + esc(p.id) + '">' + esc(p.t) + '</a></li>'; }).join('') + '</ul>';
      Array.prototype.forEach.call(box.querySelectorAll('[data-focus]'), function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); focusField(document.getElementById(a.dataset.focus)); });
      });
      list.forEach(function (p) {
        if (p.kind === 'breed' && msg) { msg.textContent = T.breedErr; pick && pick.setAttribute('aria-invalid', 'true'); }
        if (p.kind === 'photo') setMsg(p.t, 'err');
        if (p.kind === 'back') { document.getElementById(p.id + '-msg').textContent = T.backMissingInline; document.getElementById(p.id).setAttribute('aria-invalid', true); }
        if (p.kind === 'text') { document.getElementById(p.id + '-msg').textContent = TX.missingInline; document.getElementById(p.id).setAttribute('aria-invalid', true); }
        if (p.kind === 'pzphoto') { var P_ = pzByInput(document.getElementById(p.id)); if (P_) P_.msg(SZ.photoMissingInline, 'err'); }
        if (p.kind === 'pztext' || p.kind === 'pzbad') { document.getElementById(p.id + '-msg').textContent = p.kind === 'pztext' ? SZ.missingInline : p.inline; document.getElementById(p.id).setAttribute('aria-invalid', true); }
      });
    }
    function focusField(el) {
      if (!el) return;
      var box = el.closest('.ph-bpick, .ph-tf, .ph-field, .ph-opt, .ph-up');
      if (sheet && sheet.contains(el) && root.classList.contains('js-sheet')) { el = field; box = field.closest('.ph-bpick'); }
      if (box) box.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
      el.focus({ preventScroll: true });
    }

    /* ---------- price, returns, consent ---------- */
    function update() {
      var m = metal(), price = m ? +m.dataset.price : 0;
      var total = (price + (C.addon && S.back ? C.addon.price : 0) + (photoWanted() && C.photoAddon ? C.photoAddon.price : 0)) * qty();   // P-062: x quantity
      var p = $('[data-ph-price]'); if (p) p.textContent = money(price, C.moneyFormat);
      var cmp = $('[data-ph-compare]'), cv = m ? +m.dataset.compare || 0 : 0;   // compare-at only when above the price
      if (cmp) { cmp.hidden = !(cv > price); cmp.textContent = cv > price ? money(cv, C.moneyFormat) : ''; }
      if (window.PetalHushQB) total = window.PetalHushQB.total(form, total, price, qty());   // P-092b: tile price x qty + gift boxes (no-op without its blocks)
      var t = $('[data-ph-total]'); if (t) t.textContent = money(total, C.moneyFormat);
      var bp = backBox && backBox.closest('label') ? backBox.closest('label').querySelector('b') : null;   // P-062: "+$9 each" at qty > 1 (fees are per piece)
      if (bp) { if (bp.dataset.base == null) bp.dataset.base = bp.textContent; bp.textContent = bp.dataset.base + (qty() > 1 ? ' ' + ((qtyEl && qtyEl.getAttribute('data-ph-each')) || 'each') : ''); }
      var st = $('[data-ph-st-price]'); if (st) st.textContent = money(total, C.moneyFormat);
      var consent = $('[data-ph-consent]'); if (consent) consent.disabled = !(hasPhoto() || (SZ && pzPhotos.some(function (P) { return P.has(); })));   // _Consent posts only with a photo
      var engraved = !!(backField && !backField.disabled && backField.value.trim());
      var rp = $('[data-ph-ret="plain"]'), re = $('[data-ph-ret="engraved"]'), rph = $('[data-ph-ret="photo"]');
      var sculpt = photoWanted() || !!(PF && isCustom());   // a photo sculpt makes it personalized too (lead, 2026-10-10); P-084: Mixed breed always comes with a photo
      var rt = SINGLE ? $('[data-ph-ret="text"]') : null;   // P-041: names (required, or typed) make it personalized
      var named = SINGLE && (texts.some(function (f) { return f.required || tval(f); }) || (SZ && pzNamed()));
      if (rp) rp.hidden = engraved || sculpt || named;
      if (re) re.hidden = !engraved;
      if (rph) rph.hidden = engraved || !sculpt;
      if (rt) rt.hidden = !named || engraved || sculpt;
      if (rp && !re && !rph && !rt) rp.hidden = false;
      if (PF) paintPF();   // P-084: no-photo line / returns note follow the photo
      paintSel();   // breed panel follows the photo (From your photo / Optional with a photo)
      if (S.tried) showErrors(problems());
    }

    /* ---------- URL (?variant=…&breed=slug), shareable and used by ads ---------- */
    function syncUrl() {
      if (!window.history.replaceState) return;
      var u = new URL(window.location.href), m = metal(), b = breed();
      if (m) u.searchParams.set('variant', m.value);
      if (b) u.searchParams.set('breed', b.dataset.slug); else u.searchParams.delete('breed');
      window.history.replaceState(window.history.state, '', u.toString());
    }

    /* ---------- add to bag ---------- */
    function postJSON(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
    }
    function cartSections() {   // Horizon cart drawer / cart page sections, rendered by Shopify with the add (like Horizon's own forms)
      var ids = Array.prototype.map.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (n) { return n.dataset.sectionId; });
      return ids.filter(function (x, i) { return x && ids.indexOf(x) === i; }).slice(0, 5);
    }
    function openDrawer() {   // founder r4: the cart drawer slides out after every add (Horizon <theme-drawer id="cart-drawer">)
      setTimeout(function () { var td = document.getElementById('cart-drawer'); if (td && typeof td.open === 'function' && !td.isOpen) td.open(); }, 60);
    }
    /* P-098: "the bag looks empty right after Add to bag". A photo upload takes 5–30 s on a phone; the buttons gave no
       sign of it, the sticky button wasn't locked (each tap started another add), and a bag opened meanwhile said
       "Your bag is empty". While an add runs: both buttons show T.addingBag and ignore taps, the status line says it,
       and an open drawer shows T.addingBag instead of the empty state (html[data-ph-adding], petalhush-product.css).
       After the add the drawer must show the lines: if it still shows the empty state, Horizon re-renders it; if that
       fails too (or the theme events never load), the shopper goes to the cart page, which always shows the bag. */
    var busyBtns = function () { return [$('[data-ph-add]'), $('[data-ph-st-btn]')].filter(Boolean); };
    function busyOn() {
      S.adding = true;
      var h = document.documentElement, txt = T.addingBag || 'Adding to your bag…';
      busyBtns().forEach(function (x) { x.classList.add('is-adding'); x.setAttribute('aria-disabled', 'true'); x.setAttribute('aria-busy', 'true'); x.setAttribute('aria-label', txt); });
      h.style.setProperty('--ph-adding-text', JSON.stringify(txt)); h.setAttribute('data-ph-adding', '');
      var st = $('[data-ph-added]'); if (st) st.textContent = txt;
    }
    function busyOff(keepDrawer) {
      S.adding = false;
      busyBtns().forEach(function (x) { x.classList.remove('is-adding'); x.removeAttribute('aria-disabled'); x.removeAttribute('aria-busy'); x.removeAttribute('aria-label'); });
      if (!keepDrawer) document.documentElement.removeAttribute('data-ph-adding');
    }
    function goCart() { document.documentElement.removeAttribute('data-ph-adding'); window.location.href = C.routes.cart; }
    function watchDrawer(E, lines, count) {   // P-098: never leave an open bag on "Your bag is empty" once lines are in it
      var td = document.getElementById('cart-drawer'), t0 = Date.now(), again = false, tAgain = 0;
      var done = function () { document.documentElement.removeAttribute('data-ph-adding'); };
      if (!td || !count) return done();
      (function check() {
        if (!td.querySelector('.cart-drawer--empty')) return done();   // the lines are in
        var dt = Date.now() - t0;
        if (!again && dt > 1500) {   // Horizon re-renders the drawer itself (no sections = its own fresh render)
          again = true; tAgain = Date.now();
          if (E) try { var d = E.createPromise(); document.dispatchEvent(new E({ action: 'update', context: 'product', lines: [], promise: d.promise }));
            d.resolve({ cart: null, detail: { itemCount: count, source: 'petalhush-breed', didError: false } }); } catch (e) { /* fall through to the cart page */ }
        }
        if (again && Date.now() - tAgain > 4500) return goCart();   // 4.5 s after the re-render was asked (timers freeze in a backgrounded tab)
        setTimeout(check, 150);
      })();
    }
    function notifyTheme(lines, sections) {   // Horizon: Shopify's standard cart event (+ rendered sections); Dawn: re-render the bag icon
      var dawn = function () {
        if (document.getElementById('cart-drawer')) return goCart();   // P-098: Horizon without its events module: the drawer would stay stale
        document.documentElement.removeAttribute('data-ph-adding');
        var bubble = document.getElementById('cart-icon-bubble'); if (!bubble) return;
        fetch(C.routes.root + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
          var html = j['cart-icon-bubble']; if (!html) return;
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var fresh = tmp.querySelector('.shopify-section') || tmp; bubble.innerHTML = fresh.innerHTML;
        }).catch(function () {});
      };
      // window.PetalHushEvents = import('@shopify/events') promise, set by an inline script in the section: a literal
      // import() in this file would be rewritten to require() by Shopify's asset minifier.
      if (!document.querySelector('script[type="importmap"]') || !window.PetalHushEvents) return dawn();
      Promise.resolve(window.PetalHushEvents).then(function (mod) {
        if (!mod) return dawn();
        var E = mod.CartLinesUpdateEvent; if (!E || !E.createPromise) return dawn();
        var d = E.createPromise();
        document.dispatchEvent(new E({ action: 'add', context: 'product', lines: lines, promise: d.promise }));
        fetch(C.routes.root.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          d.resolve({ cart: E.createCartFromAjaxResponse ? E.createCartFromAjaxResponse(c) : null,
                      detail: { items: c.items, itemCount: c.item_count, source: 'petalhush-breed', sections: sections || undefined, didError: false } });
          openDrawer();
          watchDrawer(E, lines, c.item_count);
        }).catch(function (e) { d.reject(e); goCart(); });   // P-098: the add went through; show the bag rather than a stale drawer
      }).catch(dawn);
    }
    function addToBag() {
      var MS = window.PetalHushSet && window.PetalHushSet.get ? window.PetalHushSet.get(form) : null, setOn = !!(MS && MS.count());   // P-086 matching set
      if (setOn && !MS.check()) return;   // P-086: a ticked piece without a variant in that material (message shown by the set block)
      var fd = new FormData(form), m = metal(), b = breed();
      if (SINGLE) texts.forEach(function (f) { fd.set(f.name, tval(f)); });   // P-041: trimmed, NFC; blank ones are dropped next
      if (SZ) pzBoxes().forEach(function (box) {   // P-045: an empty (optional) photo never posts; text trimmed, initials upper-cased
        var inp = box.querySelector('input'); if (!inp || inp.disabled) return;
        if (inp.type === 'file') { var P = pzByInput(inp); if (!(P && P.has())) fd.delete(inp.name); }
        else fd.set(inp.name, pzVal(inp));
      });
      Array.from(fd.entries()).forEach(function (e) { if (e[0].indexOf('properties[') === 0 && e[1] === '') fd.delete(e[0]); });
      var photo = hasPhoto();
      if (file && !photo) fd.delete('properties[Photo 1]');
      if (file && photo && !C.photoAddon && !PF) { fd.delete('properties[Photo 1]'); fd.delete('properties[_Consent]'); photo = false; }   // never a free photo
      var sku = m && m.dataset.sku ? m.dataset.sku : (m ? m.value : '');
      var breedName = b ? b.value : SINGLE ? (C.title || '') : '';   // single design: "SKU · product title"
      if (!SINGLE && !b && photo) {   // photo, no breed: the workshop models the dog from the photo (founder 2026-10-10)
        breedName = T.fromPhoto || 'From your photo';
        fd.set('properties[' + (C.breedProp || 'Breed') + ']', breedName);
        fd.set('properties[_Breed code]', 'custom');
        if (T.heroImage) fd.set('properties[_Breed image]', T.heroImage);
      }
      var pair = 'ph' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      var forWhat = [sku, breedName].filter(Boolean).join(' · ');
      var items = [];
      var n = qty();   // P-062: one fee per piece (the pair-sync rule)
      if (C.addon && S.back) items.push({ id: C.addon.id, quantity: n, properties: { '_Back engraving for': forWhat, '_Pair id': pair } });
      if (C.photoAddon && photo) items.push({ id: C.photoAddon.id, quantity: n, properties: { '_Photo for': forWhat, '_Pair id': pair } });
      if (items.length) fd.append('properties[_Pair id]', pair);
      if (window.PetalHushQB) items = items.concat(window.PetalHushQB.items(form, forWhat, fd));   // P-092b: the gift box joins the add-on call (rolled back with it)
      var btn = $('[data-ph-add]'); btn.disabled = true; busyOn();   // P-098
      var pvRef = PV && fd.has('properties[_Preview job]') ? PV.added() : null;   // P-066: this job now belongs to a bag line (undone below if the add fails)
      var keys = [], setLines = [];
      var secIds = cartSections(), sectionsHtml = null;
      if (secIds.length) { fd.set('sections', secIds.join(',')); fd.set('sections_url', window.location.pathname + window.location.search); }
      var addMain = function () {
        if (setOn) return MS.add(fd, n).then(function (j) { sectionsHtml = j.sections || null; setLines = j.lines || []; return j; });   // P-086: main + ticked pieces
        return phPost(C.routes.cartAdd, fd, T).then(function (j) { sectionsHtml = j.sections || null; return j; });   // P-102: XHR = upload progress
      };
      var rollback = function () {
        if (!keys.length) return Promise.resolve();
        var upd = {}; keys.forEach(function (k) { upd[k] = 0; });
        return postJSON(C.routes.root.replace(/\/$/, '') + '/cart/update.js', { updates: upd }).catch(function () {});
      };
      var step1 = items.length ? postJSON(C.routes.cartAdd + '.js', { items: items }).then(function (j) { keys = (j.items || []).map(function (x) { return x.key; }); }) : Promise.resolve();
      var slims = [];   // P-102: each photo field still in the form + its state (the copy swaps in before any add)
      if (file && S.photo) slims.push([file.name, S.photo]);
      pzPhotos.forEach(function (P) { if (P.photo) slims.push([P.input.name, P.photo]); });
      Promise.all([step1, phUpFd(fd, slims, T).then(function (rest) { return phSlimFd(fd, rest); })]).then(function () {   // P-102b: pre-uploaded photos go as their URL
        return addMain().catch(function (err) { return rollback().then(function () { throw err; }); });
      }).then(function () {
        S.tried = false;
        $('[data-ph-added]').innerHTML = esc(T.addedToBag) + ' <a href="' + esc(C.routes.cart) + '">' + esc(T.viewBag) + ' ›</a>';
        notifyTheme([{ merchandiseId: String(m.value), quantity: n }].concat(items.map(function (x) { return { merchandiseId: String(x.id), quantity: x.quantity }; })).concat(setLines), sectionsHtml);
        document.dispatchEvent(new CustomEvent('ph:cart:added', { detail: { variant: m.value, breed: b && b.dataset.slug, pair: items.length ? pair : null, quantity: n } }));
        busyOff(true);   // P-098: the drawer keeps "Adding…" until the lines show (watchDrawer)
      }).catch(function (err) {
        busyOff(false); $('[data-ph-added]').textContent = '';
        if (pvRef) PV.unadd(pvRef);
        if (!(err && err.phShown)) $('[data-ph-error]').innerHTML = '<b>' + esc(T.errGeneric) + '</b>';   // P-086: the set block wrote its own message
      }).then(function () { btn.disabled = false; });
    }
    function submit() {
      if (S.adding) return;   // P-098: one add at a time (the sticky button was never locked)
      $('[data-ph-added]').textContent = '';
      S.tried = true;
      var list = problems();
      showErrors(list);
      if (list.length) { focusField(document.getElementById(list[0].id)); return; }
      addToBag();
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });

    /* ---------- sticky bar (phones) ---------- */
    var sticky = $('[data-ph-sticky]'), stBtn = $('[data-ph-st-btn]'), target = $('[data-ph-add]');
    if (sticky && target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var show = !es[0].isIntersecting && es[0].boundingClientRect.top > 0;   // only while the button is still below
        sticky.classList.toggle('is-shown', show); sticky.setAttribute('aria-hidden', !show); stBtn.tabIndex = show ? 0 : -1;
      }).observe(target);
    }
    if (stBtn) stBtn.addEventListener('click', submit);

    /* ---------- accordion openers ---------- */
    $$('[data-ph-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var d = document.getElementById(a.dataset.phOpen); if (!d) return;
        e.preventDefault(); d.open = true;
        d.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        d.querySelector('summary').focus({ preventScroll: true });
      });
    });

    /* ---------- ?breed=slug preselects (ads, shared links). Never a default otherwise. ---------- */
    var qs = new URLSearchParams(window.location.search), want = qs.get('breed');
    if (want) {
      var hit = tiles.filter(function (t) { return t.dataset.slug === String(want).toLowerCase(); })[0];
      if (hit) hit.checked = true;
    }
    paintTiles(); paintSel(); paintMain(); paintCustom(false); renderThumbs(); update(); if (q) filter();
  }

  function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ph-breed]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
